const product = require('./complot-bottle.png')
const poster = require('./complot-poster.png')
const video = require('./complot.mp4')
const videoMobile = require('./complot-mobile.mp4')

export default {
  product,
  poster,
  video,
  videoMobile
}
